import { Lightbulb, HandHeart, TrendingUp } from "lucide-react";

const pillars = [
  {
    icon: Lightbulb,
    title: "Teknologi og erfaring",
    description:
      "Vi kombinerer moderne teknologi med dyb sundhedsfaglig indsigt. Vores system matcher hurtigt – men det er vores erfaring fra praksis, der sikrer kvaliteten.",
  },
  {
    icon: HandHeart,
    title: "Ordentlighed først",
    description:
      "Vi tror på gennemsigtighed, fair vilkår og respekt for alle parter. Det gælder både overfor vikarer og de institutioner, vi samarbejder med.",
  },
  {
    icon: TrendingUp,
    title: "Langsigtede relationer",
    description:
      "Vi bygger samarbejder der varer. Faste relationer giver bedre bemanding, gladere medarbejdere og trygge borgere.",
  },
];

export default function VoresTilgang() {
  return (
    <section className="section py-10 sm:py-14 md:py-18 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="kicker">Vores tilgang</span>
          <h2 className="section-title mt-2">
            Teknologi og erfaring – kombineret
          </h2>
          <p className="section-subtitle mx-auto">
            Vi er ikke bare et vikarbureau. Vi er en samarbejdspartner der
            investerer i langsigtede relationer og ordentlige løsninger.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pillars.map((p) => (
            <div key={p.title} className="card-elevated p-6 text-center">
              <div className="w-12 h-12 rounded-xl bg-brand-50 flex items-center justify-center mx-auto mb-4">
                <p.icon className="text-brand-600" size={24} />
              </div>
              <h3 className="font-semibold text-slate-900 text-base">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
